// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-HckrJVmF","breadcrumbs":"breadcrumbs-2CkZQpy-"};